'use strict';

var buildDateUnitMethods = require('../internal/buildDateUnitMethods');

buildDateUnitMethods();


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/build/buildDateUnitMethodsCall.js
// module id = 2
// module chunks = 1